import styled from 'styled-components';
import { Modal, ModalProps } from 'antd';

const StyledModal = styled(Modal)`
  top: 50px !important;
  ${({ theme }) =>
      theme.media.monitor(
      ` 
        height: 750px !important;
        width: 700px !important;
      `,
      )}
      
  .ant-modal-title {
    font-size: 22px;
    font-weight: 700;
    font-family: 'Suit medium', sans-serif;
    text-align: left;
    color: rgba(0, 0, 0, 0.87);
    margin-top: 5px;
    ${({ theme }) =>
      theme.media.monitor(
      `  
        font-size: 24px;
      `,
      )}
      
  } 
`

export function MainModal({ ...restProps }: ModalProps) {
  return <StyledModal {...restProps}/>;
}
